// Разблокировка оружия по факту победы над боссом. Реализовано 9 оружий — 2 стартовых
// + 7 за победы над боссами 5/10/15/20/25/30/35. Боссы 40 (Верблюд) и 45 (Медведь) НЕ
// дают оружие — это финальные испытания, награда = ощущение прохождения.
// Структурная пересборка W2: номера сдвинуты −5 синхронно с LEVEL_OVERRIDES.
// Порядок боссов сохранён — соответствие "босс → оружие" не изменилось.
export interface WeaponUnlock {
  weaponId: string;
  unlockedAfterLevel: number; // 0 = доступно с начала
}

export const WEAPON_UNLOCKS: WeaponUnlock[] = [
  { weaponId: 'revolver', unlockedAfterLevel: 0 }, // старт, в руках
  { weaponId: 'dual_revolver', unlockedAfterLevel: 0 }, // доступно сразу к покупке
  { weaponId: 'assault_rifle', unlockedAfterLevel: 5 }, // после Кабана
  { weaponId: 'shotgun', unlockedAfterLevel: 10 }, // после Волны Кабанчиков (своп W13)
  { weaponId: 'uzi', unlockedAfterLevel: 15 }, // после Волны Лис (своп W13)
  { weaponId: 'sniper', unlockedAfterLevel: 20 }, // после Волны Оленей
  { weaponId: 'machinegun', unlockedAfterLevel: 25 }, // после Лося
  { weaponId: 'grenade_launcher', unlockedAfterLevel: 30 }, // после Медоеда
  { weaponId: 'laser', unlockedAfterLevel: 35 }, // после Волны Волков (финальный unlock)
];

export function getUnlockedWeapons(completedLevels: number[]): string[] {
  return WEAPON_UNLOCKS.filter(
    (w) => w.unlockedAfterLevel === 0 || completedLevels.includes(w.unlockedAfterLevel),
  ).map((w) => w.weaponId);
}
